import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateKeyDescription$ } from "../schemas/schemas_0";
export { $Command };
export class UpdateKeyDescriptionCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "UpdateKeyDescription", {})
    .n("KMSClient", "UpdateKeyDescriptionCommand")
    .sc(UpdateKeyDescription$)
    .build() {
}
